<template>
	<div>
		<firstsceenimage :imgobj='banner' title="星链订货平台" title2="一站式鞋履供应链平台" subtitle="从数字选款到大货成品交付" button="white"
			stylemode="white">
			<button
				style=" font-size: 13px; border: 1px solid #E8C570;color: black; margin-top: 25px;line-height: 32px;  width: 80px; height: 32px;background-color: #E8C570;">
				预约演示
			</button>
		</firstsceenimage>

		<div style="padding-top: 120px;padding-bottom: 120px;">
			<div class="flexspacebetween" style="text-align: center; width: 45%;margin-left: auto;margin-right: auto;">
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/在线订货，便捷安心ico.png" />
					<div style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;">
						在线订货，便捷安心
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;">

						在线订货会，每日上新、热销单品、<br>订单信息一手掌握
					</div>
				</div>
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/趋势分析，爆款直达ico.png" />
					<div style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;">
						趋势分析，爆款直达
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;">
						AI大数据分析，流行趋势一键查<br>看，爆款信息即时同步
					</div>
				</div>
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/柔性生产，小单快反ico.png" />
					<div style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;">
						柔性生产，小单快反
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;">
						300+工厂在线接单，小批量、快反<br>应、质量佳
					</div>
				</div>

			</div>

		</div>
		<adword style="background-color: #070E1D;color: white;" title="星链鞋履供应链解决方案" slotheight="680">

			<img style="width: 30%;" src="../../static/星链鞋履供应链解决方案.png" />

		</adword>

		<!--  -->
		<div v-if="isShowNavAD"  ref="liuchengimgref">
			<adword :style="{backgroundImage: 'url('+backimg+') ' }"
				style="background-repeat:no-repeat;background-position:left bottom ;background-color:#F8F8F8 ;"
				title="智能定制全流程" viewheight="580">
				<div>
					<div style="height: 45px;"></div>
					<div>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="margin-left: 150px;"
								src="../../static/订货ico-1.png" />
						</transition>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="margin-left: 100px; "
								src="../../static/打样ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/订货ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/订单归集ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/单产ico.png" />
						</transition>
						<transition name="adfadex5">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/收货ico.png" />
						</transition>

					</div>

					<div style="text-align: left;">
						<img v-if="liuchengimgshow" :class="[liuchengimgshow?'adfadew1':'']"
							style="margin-left: 22%; width: 67%;height: 17px;" src="../../static/轴承ico3.png">
					</div>


					<div>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="margin-left: 70px;"
								src="../../static/款式设计ico.png" />
						</transition>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/3D渲染ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/上新ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/下单ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/订单分发ico.png" />
						</transition>
						<transition name="adfadex5">
							<img v-if="liuchengimgshow" style="margin-left: 100px;"
								src="../../static/发货ico.png" />
						</transition>

					</div>
				</div>

			</adword>
		</div>
		<!--  -->


		<!--  -->
		<adword title="订货会" :subtitle="subtitile" slotheight="680">
			
				<div class="flexcenter" style="margin-top: 130px;">
					<div style="text-align: left;">
						<div @click="selecttab(0)" class="ordersystemtext1" :class="[selectindex==0?'ordersystemselect':'ordersystemnoselect']"
							:style="{backgroundImage: 'url('+backimg2+') ' }"
							style="background-repeat:no-repeat; background-position:right top ;">
							<div
								style="font-size: 18px;font-weight: bold;padding: 30px 30px 20px 30px;letter-spacing: 4px;">
								单独空间，私域订货 </div>
							<div :class="[selectindex==0?'ordersystemselect':'color2']"
								style="font-size: 12px;;padding: 00px 20px 20px 30px;letter-spacing: 3px;opacity: 0.5;">
								可为每一场订货会单独开辟私域空间，限定对象入场。</div>
						</div>
						<div @click="selecttab(1)"  class="ordersystemtext1" :class="[selectindex==1?'ordersystemselect':'ordersystemnoselect']"
							:style="{backgroundImage: 'url('+backimg2+') ' }"
							style="background-repeat:no-repeat; background-position:right top ;">
							<div
								style="font-size: 18px;font-weight: bold;padding: 30px 30px 20px 30px;letter-spacing: 4px;">
								多端互动，多场景使用</div>
							<div :class="[selectindex==1?'ordersystemselect':'color2']"
								style="font-size: 12px;;padding: 00px 20px 20px 30px;letter-spacing: 3px;opacity: 0.5;">
								手机端/PAD端等多端即时互动，线上/现场等多场景使用。</div>
						</div>
						<div @click="selecttab(2)"  class="ordersystemtext1" :class="[selectindex==2?'ordersystemselect':'ordersystemnoselect']"
							:style="{backgroundImage: 'url('+backimg2+') ' }"
							style="background-repeat:no-repeat; background-position:right top ;">
							<div
								style="font-size: 18px;font-weight: bold;padding: 30px 30px 20px 30px;letter-spacing: 4px;">
								强大的数据分析与展示平台 </div>
							<div :class="[selectindex==2?'ordersystemselect':'color2']"
								style="font-size: 12px;;padding: 00px 20px 20px 30px;letter-spacing: 3px;opacity: 0.5; ">
								强大的后台数据分析功能，给予品牌方、供应方、代理商、买手等强大数据指导。</div>
						</div>
					</div>
					<div  style="position:relative;">
						<img v-if="isShowNavAD" style="bottom:-37.5px; right:-46.5px; position :absolute;width:97px;height: 79px;opacity:0.5;"  src="../../static/订货会方块.png" />
						<img class="boxshadow ordersystemimage1" v-if="selectindex==0" 
							src="../../static/单独空间，私域订货.png" />
						<img class="boxshadow ordersystemimage1" v-if="selectindex==1"   src="" />
						<img class="boxshadow ordersystemimage1" v-if="selectindex==2"   src="" />
						
					</div>
				</div>
			
		</adword>
		<!--  -->
	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimagespecial.vue'
	import Adbigwordbutton from '../../components/adBigWordButton.vue'
	import adword from '../../components/adword.vue'
	import banner from '../../static/星链订货平台banner.png'
	import img2 from '../../static/脚型报告智能推荐鞋款.png'
	import img3 from '../../static/C2M智能定制.png'
	import backimg from '../../static/星链鞋履供应链解决方案水印.png'
	import backimg2 from '../../static/水印4.png'
	// import video from '../../assets/video/2.mp4'

	export default {
		name: 'Ordersystem',
		components: {
			firstsceenimage,
			adword,
			Adbigwordbutton,
			// advideo,
		},
		data() {
			return {
				banner: banner,
				img2: img2,
				img3: img3,
				backimg: backimg,
				backimg2: backimg2,
				selectindex: 0,


				liuchengimgtop: 0,
				liuchengimgshow: false,
				subtitile: "基于大型线下订货会需求打造的一款无线订货会系统，订货平台拥有强大的订货功能与强大的后台数据分析功能等，可以帮助用户更好的订货。配合PAD使用，显示货品图片、相关搭配产品，客户可直接搭配订货，并可以通过Pad实时查看款式排名和订货完成率，并能对类别、价格带、波段、颜色、尺码等八项关键指标进行实时分析，并针对性的对订单进行修改，使用起来非常便利直观。",
				isShowNavAD: false,
			}
		},
		mounted() {
			
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			} else {
				this.isShowNavAD = true
			}
			
			var _this = this
			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			setTimeout(() => {
				_this.liuchengimgtop = this.$refs.liuchengimgref.offsetTop
			}, 200);


		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示1
				if (!this.liuchengimgshow) {
					if (this.vscrolltop > this.liuchengimgtop) {
						this.liuchengimgshow = true;
					}
				}


			},
			selecttab: function(index) {
				this.selectindex = index
			}

		},

	}
</script>

<style>
	.ordersystemselect {

		background-color: #263E8B;
		color: #FFFFFF;

	}

	.ordersystemnoselect {
		background-color: #F8F8F8;
	}
	.color2{
		color: #1D1F29;
	}
	
	@media (min-width: 1px) {
	 .ordersystemimage1{
	 	width:60%;
	  
	 }
	 .ordersystemtext1{
	 		 width: 100%;
	 		 height: 159px;
	 }
	}
	
	@media (min-width: 1000px) {
	 .ordersystemimage1{
	 	width: 710px;
		height: 477px;
	 }
	 .ordersystemtext1{
		 width: 468px;
		 height: 159px;
	 }
	}
	

</style>
